import {
    Box,
    Typography,
  } from "@mui/material";

const TitleSection = ({
  title,
  subtitle,
}: {
  title: string;
  subtitle?: string;
}) => {
  return (
    <>
      <Box marginY={2}>
        <Typography variant="h6" fontWeight="bold">
          {title}
        </Typography>
        <Typography variant="body2">{subtitle}</Typography>
      </Box>
    </>
  );
};

export default TitleSection;
